module.exports = __webpack_public_path__ + "media/images/icon_settings-e7c53fb8ee137f93827e2db21f507cb1.png";